import { Component, Input, Optional, Self } from '@angular/core'
import { AbstractControl, NgControl } from '@angular/forms'
import { BaseControlValueAccessor } from '@shared/base-control-value-acessor'
import { GrauSatisfacaoDomainModel, GrauSatisfacaoDomainModelList } from '@shared/models/backend'

@Component({
  selector: 'app-satisfacao-picker',
  templateUrl: './satisfacao-picker.component.html',
  styleUrls: ['./satisfacao-picker.component.scss'],
})
export class SatisfacaoPickerComponent extends BaseControlValueAccessor<GrauSatisfacaoDomainModel> {
  @Input()
  control: AbstractControl

  private grauSatisfacaoMap: Map<number, string>

  constructor(@Self() @Optional() public ngControl: NgControl) {
    super()
    this.grauSatisfacaoMap = new Map([
      [1, 'sentiment_very_dissatisfied'],
      [2, 'sentiment_dissatisfied'],
      [3, 'sentiment_neutral'],
      [4, 'sentiment_satisfied'],
      [5, 'sentiment_very_satisfied'],
    ])
    if (this.ngControl) {
      this.ngControl.valueAccessor = this
    }
  }

  writeValue(obj: GrauSatisfacaoDomainModel): void {
    this.control.setValue(obj)
  }

  registerOnChange(fn) {
    super.registerOnChange(fn)
  }

  getMatIcon(grau: number): string {
    return this.grauSatisfacaoMap.get(grau)
  }

  getSatisfacaoModel(grau: number): GrauSatisfacaoDomainModel {
    return (GrauSatisfacaoDomainModelList.find((el) => el.id == grau) as unknown) as GrauSatisfacaoDomainModel
  }
}
